export default __webpack_public_path__ + "static/media/CreateBackupJobDetails-Oracle.4b26f1da.png";